import { Event as BigReactEvent } from 'react-big-calendar';
import { TaskFull } from './task.interface';
import { dayjs } from '@umanforge/common';
import { RoleTaskFullIds } from './roleTask.interface';


export class CalendarEvent implements BigReactEvent {
  // BigReactEvent
  allDay?: boolean | undefined;
  resource?: unknown;
  title?: React.ReactNode | undefined;
  start?: Date | undefined;
  end?: Date | undefined;

  desc?: string;
  task?: TaskFull;
  roleTasks?: RoleTaskFullIds[];
  id?: string;

  temporary?: boolean;
  editable?: boolean;
  understaffed?: boolean;
  stacked?: boolean;
  resizable?: boolean;
  draggable?: boolean;

  // allDay event
  allDayIndicator?: boolean | undefined;
  allDayOver?: boolean = false;
  allDayColor?: string = '#ff1010';
  allDayLast?: boolean | undefined;
  fullDay?: boolean | undefined;

  constructor(
    task : TaskFull,
    desc?: string,
    title?: string | undefined,
    start?: Date | undefined,
    end?: Date | undefined,
    editable?: boolean,
    resizable: boolean = true,
    draggable: boolean = true,

    allDayIndicator?: boolean
  ) {
    this.task = task;
    this.title = title ?? task.taskAction.name;
    this.start = start ?? dayjs( task.dateStart ).toDate();
    this.end = end ?? dayjs( task.dateEnd ).toDate();
    this.id = task.id;

    this.allDay = !dayjs( task.dateStart ).startOf( 'day' ).isSame( dayjs( task.dateEnd ).startOf( 'day' ) );
    this.fullDay = ( dayjs( task.dateStart ).format( 'HH:mm' ) === '00:00' && dayjs( task.dateEnd ).format( 'HH:mm' ) === '23:59' );
    this.desc = desc;
    this.temporary = false;
    this.stacked = false;
    this.editable = editable;
    this.understaffed = false;
    this.allDayIndicator = allDayIndicator;
    this.resizable = resizable;
    this.draggable = draggable;
  }
}